
import { Component, OnInit } from '@angular/core';
import { HostingService } from '../../services/hosting.service';
import { Hosting } from '../../models/HostingModel';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SuperAdminNavbarComponent } from '../../components/superadmin-navbar/superadmin-navbar.component';

@Component({
  selector: 'app-superadmin-hostings-list',
  templateUrl: './superadmin-hostings-list.component.html',
  styleUrl: './superadmin-hostings-list.component.css',
  standalone: true,
  imports: [
    CommonModule, 
    FormsModule, 
    RouterLink,
    SuperAdminNavbarComponent
  ]
})
export class SuperadminHostingsListComponent implements OnInit {
  hostings: Hosting[] = [];
  isLoading = false;
  errorMsg = '';
  editHostingId: string | null = null;
  editedHosting: Partial<Hosting> = {};

  constructor(private hostingService: HostingService) {}

  ngOnInit() {
    this.loadHostings();
  }

  async loadHostings() {
    this.isLoading = true;
    this.errorMsg = '';
    try {
      this.hostings = await this.hostingService.getAllHostings();
    } catch (err) {
      this.errorMsg = 'Error cargando alojamientos';
    }
    this.isLoading = false;
  }

  startEdit(hosting: Hosting) {
    this.editHostingId = hosting.id;
    this.editedHosting = { ...hosting };
    this.editedHosting.location = this.editedHosting.location ?? { city: '' } as any;
  }

  get editedHostingLocationCity(): string {
    return this.editedHosting.location?.city ?? '';
  }
  set editedHostingLocationCity(value: string) {
    if (!this.editedHosting.location) {
      this.editedHosting.location = { city: value } as any;
    } else {
      this.editedHosting.location.city = value;
    }
  }

  cancelEdit() {
    this.editHostingId = null;
    this.editedHosting = {};
  }

  async saveEdit(hosting: Hosting) {
    if (!this.editedHosting) return;
    try {
      await this.hostingService.updateHosting(hosting.id, this.editedHosting as Hosting).toPromise();
      this.editHostingId = null;
      this.loadHostings();
    } catch (err) {
      this.errorMsg = 'Error actualizando alojamiento';
    }
  }

  async deleteHosting(id: string) {
    if (!confirm('¿Seguro que deseas eliminar este alojamiento?')) return;
    try {
      await this.hostingService.deleteHosting(id).toPromise();
      this.loadHostings();
    } catch (err) {
      this.errorMsg = 'Error eliminando alojamiento';
    }
  }

  ensureLocation() {
    if (!this.editedHosting.location) {
      this.editedHosting.location = { city: '' } as any;
    }
  }
}
